import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Eye, Send, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate, fmtDateTime } from "@/lib/util";
import { BackBar, Loader, Money, Row, FileButton, VehNo } from "@/components/common";
import { tr as t, Auto } from "@/lib/i18n";

export default function ViolationView() {
  const { id } = useParams();
  const [v, setV] = useState(null);
  const [reply, setReply] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/violations/${id}`).then((r) => setV(r.data)).catch((e) => { toast.error(errMsg(e)); setV(false); }); }, [id]);

  const act = async (fn, ok) => {
    setBusy(true);
    try { setV((await fn()).data); toast.success(ok); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div>
      <BackBar title={t("مخالفة مرورية")} />
      {v === null ? <Loader /> : !v ? <p className="p-6 text-center">{t("المخالفة غير موجودة")}</p> : (
        <div className="p-4 space-y-4" data-testid="violation-view">
          <div className="card p-5">
            <div className="text-center py-3">
              <div className="text-slate-500">{t("مبلغ المخالفة")}</div>
              <Money fils={v.amount_fils} className="text-4xl text-red-600" testid="violation-amount" />
            </div>
            <Row label={t("نوع المخالفة")} testid="violation-type"><Auto text={v.violation_type} /></Row>
            <Row label={t("التاريخ")}>{fmtDate(v.date)}</Row>
            <Row label={t("المركبة")}><VehNo adm={v.admin_number} plate={v.plate} /></Row>
            {v.admin_note && <Row label={t("ملاحظة الإدارة")}><Auto text={v.admin_note} /></Row>}
          </div>
          <FileButton fileId={v.file_id} label={t("فتح صورة المخالفة")} testid="violation-file-btn" className="btn btn-lg btn-ghost w-full" />
          {v.seen_at ? (
            <div className="card p-4 bg-green-50 border-green-200 text-green-800 font-bold flex items-center gap-2" data-testid="violation-seen-state">
              <CheckCircle2 className="w-6 h-6" />{t("تم الاطلاع في {d}", { d: fmtDateTime(v.seen_at) })}
            </div>
          ) : (
            <button data-testid="violation-seen-btn" disabled={busy} onClick={() => act(() => api.post(`/violations/${id}/seen`), t("تم تسجيل الاطلاع"))} className="btn btn-lg btn-red w-full">
              <Eye className="w-7 h-7" />{t("اطلعت")}</button>
          )}
          <p className="text-sm text-slate-500 text-center">{t("الضغط على «اطلعت» يعني أنك شاهدت المخالفة فقط، ولا يعتبر إقراراً بالمسؤولية.")}</p>
          <div className="card p-4 space-y-3">
            <div className="font-bold">{t("ردك أو ملاحظتك")}</div>
            {v.replies.map((r, i) => <div key={i} className={`rounded-xl p-3 ${r.from === "admin" ? "bg-blue-50" : "bg-slate-50"}`}>{r.from === "admin" && <b className="block text-blue-800 text-sm">{t("رد الإدارة")}</b>}<div>{r.from === "admin" ? <Auto text={r.text} /> : r.text}</div><div className="text-xs text-slate-500">{fmtDateTime(r.at)}</div></div>)}
            <textarea data-testid="violation-reply-input" className="field" value={reply} onChange={(e) => setReply(e.target.value)} placeholder={t("اكتب ردك هنا")} />
            <button data-testid="violation-reply-btn" disabled={busy || !reply.trim()} className="btn btn-md btn-dark w-full"
              onClick={() => act(() => api.post(`/violations/${id}/reply`, { text: reply }), t("تم إرسال الرد")).then(() => setReply(""))}><Send className="w-5 h-5" />{t("إرسال الرد")}</button>
          </div>
        </div>
      )}
    </div>
  );
}
